import ButtonLoader from '../utils/ButtonLoader'

const UserManagement = {
  el: {
    // deleteUserButton: document.querySelector('.mypage__add-form-remove-user'),
    // userFormm: document.querySelector<HTMLFormElement>('.mypage-users__add-form'), // deleteform

    applyForm: document.querySelector<HTMLFormElement>('.mypage-apply__form'),
    userForm: document.querySelector<HTMLFormElement>('.mypage-users__add-form'),
    userList: document.querySelector<HTMLElement>('.mypage-users__list-section'),
    userItems: document.querySelectorAll<HTMLElement>('.mypage-users__table tbody tr'),
    applyAlert: document.querySelector<HTMLElement>('.mypage-apply__alert'),
    deleteForm: document.querySelector<HTMLFormElement>('.mypage-delete-form'),
    deleteButton: document.querySelector<HTMLButtonElement>('.mypage__add-form-remove-user'),
    submitButton: document.querySelector<HTMLButtonElement>('[type="submit"]'),
  },
  init() {
    this.apply()
    this.delete()
    this.addForm()
  },

  handleAlert(type) {
    const textSuccess = document.querySelector('.mypage-apply__alert-text--success')
    const textError = document.querySelector('.mypage-apply__alert-text--error')

    this.el.applyAlert.classList.add(`alert--${type}`)

    if (type == 'success') {
      textSuccess.classList.remove('hide')
      textError.classList.add('hide')
    } else if (type == 'error') {
      textSuccess.classList.add('hide')
      textError.classList.remove('hide')
    }
    this.el.applyAlert.classList.remove('hide')
  },

  apply() {
    if (this.el.applyForm) {
      // var formButton = this.el.applyForm.querySelector('button[type="submit"]');

      this.el.applyForm.addEventListener('submit', (e) => {
        e.preventDefault()

        this.handleApplySubmit(this.el.applyForm)
      })
    }
  },

  addForm() {
    if (this.el.userForm) {
      this.el.userForm.addEventListener('submit', (e) => {
        ButtonLoader.start(this.el.submitButton)
      })
    }
  },

  async handleApplySubmit(form) {
    var formButton = form.querySelector('button[type="submit"]')

    this.el.applyAlert.classList.add('hide')

    ButtonLoader.start(formButton)

    const formData = new FormData(form)

    const req = await fetch(form.getAttribute('action'), {
      method: form.getAttribute('method'),
      body: formData,
    }).then((r) => r.json())

    if (req.success) {
      this.handleAlert('success')
      ButtonLoader.success(formButton)
    } else {
      this.handleAlert('error')
      ButtonLoader.reset(formButton)
    }
  },

  delete() {
    if (this.el.deleteForm && this.el.deleteButton) {
      this.el.deleteButton.addEventListener('click', (e) => {
        e.preventDefault()

        this.deleteUserSubmit()
      })
    }
  },
  async deleteUserSubmit() {
    ButtonLoader.start(this.el.deleteButton)

    const formData = new FormData(this.el.deleteForm)

    const req = await fetch(this.el.deleteForm.getAttribute('action'), {
      method: this.el.deleteForm.getAttribute('method'),
      body: formData,
    })

    if (req.status >= 200 && req.status < 300) {
      ButtonLoader.success(this.el.deleteButton)

      setTimeout(() => {
        window.history.go(-1)
      }, 1000)
    } else {
      ButtonLoader.reset(this.el.deleteButton)
    }
  },
}

export default UserManagement
